import { AxiosError } from 'axios';

import { Text } from '@mantine/core';

import { AlertError } from './AlertComponent';
import { ErrorUtils } from './ErrorUtils';
import MaxWidthLayout from './MaxWidthLayout';

export default function ServerLoadErrorFallback({
    entity,
    error
}: {
    entity: string;
    error: Error | AxiosError;
}) {
    const errorInfo = ErrorUtils.extractErrorDetails(error);
    if (!errorInfo) return null;
    const titleElement = `An error occurred while trying to load ${entity} data:`;
    const detailsElement = (
        <>
            <Text>{`Title: ${errorInfo.title ?? 'No error title available.'}`}</Text>
            <Text>{`Details: ${errorInfo.detail ?? 'No additional error details available.'}`}</Text>
            <Text>{`Status Code: ${errorInfo.responseCode ?? 'No status code available'}`}</Text>
        </>
    );
    return (
        <MaxWidthLayout>
            <AlertError summary={titleElement} details={detailsElement} />
        </MaxWidthLayout>
    );
}
